/**
 * Récupère la liste de sites / agents / clients
 * @type {string}
 */
export const USER_AGENCY_FETCH_INFOS = 'fetchInfos'

/**
 * Récupère les infos sur les listes des demandes non lues
 * @type {string}
 */
export const USER_AGENCY_GET_AGENT_REQUEST_UNREAD = 'fetchAgentRequestUnread'

/**
 * Récupère les formules de l'agence
 * @type {string}
 */
export const USER_AGENCY_GET_PRICING = 'fetchPricing'

/**
 * Récupère la liste des agencies
 * @type {string}
 */
export const USER_AGENCY_FETCH_AGENCIES = 'fetchAgencies'

/**
 * Ajouter / modifie une agence
 * @type {string}
 */
export const USER_AGENCY_POST_AGENCY = 'postAgency'

/**
 * Récupère la configuration Sekur + Agence
 * @type {string}
 */
export const USER_AGENCY_FETCH_CONFIG = 'fetchConfig'

/**
 * Récupère la liste des sites
 * @type {string}
 */
export const USER_AGENCY_FETCH_SITES = 'fetchSites'

/**
 * Ajouter / modifie un site
 * @type {string}
 */
export const USER_AGENCY_POST_SITE = 'postSite'

/**
 * Supprimer un site
 * @type {string}
 */
export const USER_AGENCY_DELETE_SITE = 'deleteSite'

/**
 * Récupère la liste des agents
 * @type {string}
 */
export const USER_AGENCY_FETCH_AGENTS = 'fetchAgents'

/**
 * Ajouter / modifie un agent
 * @type {string}
 */
export const USER_AGENCY_POST_AGENT = 'postAgent'

/**
 * Supprime un agent
 * @type {string}
 */
export const USER_AGENCY_DELETE_AGENT = 'deleteAgent'

/**
 * Récupère la liste des clients
 * @type {string}
 */
export const USER_AGENCY_FETCH_CLIENTS = 'fetchClients'

/**
 * Ajouter / modifie un client
 * @type {string}
 */
export const USER_AGENCY_POST_CLIENT = 'postClient'

/**
 * Supprime un client
 * @type {string}
 */
export const USER_AGENCY_DELETE_CLIENT = 'deleteClient'

/**
 * Récupère la liste des rondes
 * @type {string}
 */
export const USER_AGENCY_FETCH_RONDES = 'fetchRondes'

/**
 * Récupère la liste des rondes du service actif
 * @type {string}
 */
export const USER_AGENCY_FETCH_SITE_RONDES = 'fetchSiteRondes'

/**
 * Récupère créé / Met à jour une ronde
 * @type {string}
 */
export const USER_AGENCY_POST_RONDE = 'postRonde'

/**
 * Supprimer une ronde
 * @type {string}
 */
export const USER_AGENCY_DELETE_RONDE = 'deleteRonde'

/**
 * Récupère la liste des checkpoints
 * @type {string}
 */
export const USER_AGENCY_FETCH_CHECKPOINTS = 'fetchCheckpoints'

/**
 * Ajoute / met à jour un checkpoint
 * @type {string}
 */
export const USER_AGENCY_POST_CHECKPOINT = 'postCheckpoint'

/**
 * Supprimer un checkpoint
 * @type {string}
 */
export const USER_AGENCY_DELETE_CHECKPOINT = 'deleteCheckpoint'
